import React, { useEffect, useState } from "react";

const ResourcesCsx = () => {
	const [documents, setDocuments] = useState([]);

	// Fetch documents from the backend
	useEffect(() => {
		fetch(`${process.env.REACT_APP_API_URL}/sop-documents`)
			.then((response) => response.json())
			.then((data) => setDocuments(data))
			.catch((error) => console.error("Error fetching SOP documents:", error));
	}, []);

	return (
		<div className="sop-documents">
			<h1>Resources Portal</h1>
			<div className="file-list-container">
				{documents.length > 0 ? (
					documents.map((doc, index) => (
						<div className="file-item" key={doc.name || index}>
							<span className="file-name">{doc.name}</span>
							<div className="file-actions">
								<a
									href={`${
										process.env.REACT_APP_API_URL
									}/sop-documents/view?name=${encodeURIComponent(doc.name)}`}
									target="_blank"
									rel="noopener noreferrer"
								>
									<button className="view-button">View</button>
								</a>
								<a
									href={`${
										process.env.REACT_APP_API_URL
									}/sop-documents/download?name=${encodeURIComponent(
										doc.name
									)}`}
									download
								>
									<button className="download-button">Download</button>
								</a>
							</div>
						</div>
					))
				) : (
					<p>No documents available.</p>
				)}
			</div>
		</div>
	);
};

export default ResourcesCsx;
